module.exports = __webpack_public_path__ + "static/media/teygja_bakvodvar_nidurtog_a.dfd07de4.png";